import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterDeck,
  CampaignDeck,
} from "@dndModels";
import { DisablableOption } from "@models";

import API from "@dndUtilities/system_api";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import LoadingBox from "@components/input/LoadingBox";

interface Props {
  character: Character;
  char_item: CharacterDeck;
  // onChange: (repopulate: boolean, close: boolean) => void;
}

const api = API.getInstance();

export default function CharacterDeckControls({
  character,
  char_item,
  // onChange,
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [campaign_decks, setCampaignDecks] = useState<CampaignDeck[]>([]);
  const [reloading, setReloading] = useState(false);
  const [ping, setPing] = useState(false);

   
  useEffect(() => {
    if (!fetched) {
      load();
    }
  });

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const load = () => {
    // debugger;
    setFetched(true);
    if (character.old_campaign_id !== "" && char_item instanceof CharacterDeck && char_item.deck_id !== "") {
      setLoading(true);
      api.getObjects({ data_type: "campaign_deck", filter: { 
        campaign_id: character.old_campaign_id, c_options: character.c_options, deck_id: char_item.deck_id }}).then(res => {
        setCampaignDecks(res as CampaignDeck[]);
        setLoading(false);
      });
    }
  }

  const enabled = api.user && (character.owner_id === api.user._id || (character.campaign && character.campaign.owner_id === api.user._id));
  
  if (!fetched || loading) {
    return (
      <Grid
        size={{
          xs: 12
        }}><LoadingBox /></Grid>
    );
  } else {
    const options = campaign_decks.map(o => {
      const opt: DisablableOption = {
        id: o._id, text: o.name
      };
      return opt;
    });
    return (
      <Grid
        size={{
          xs: 12
        }}>
        <SelectStringBox
          name="Campaign Deck"
          options={options}
          value={char_item.campaign_deck_id}
          disabled={!enabled}
          onChange={(changed: string) => {
            if (char_item instanceof CharacterDeck) {
              char_item.campaign_deck_id = changed;
              // onChange(false, false);
              character.changed();
              character.subscription_holder.itemsChanged();
              setPing(!ping);
            }
          }}
        />
      </Grid>
    );
  }
}
